import LayoutPage from "../../Components/LayoutPage";
import ChooseAccount from "./Components/ChooseAccount";

export default function Account() {
  return (
    <LayoutPage
      activeIndex={4}
      navItems={["معامله"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <div className="w-full flex-1 flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <ChooseAccount />
      </div>
    </LayoutPage>
  );
}
